var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[(!_vm.saving)?_c('div',{staticClass:"petitBouton",on:{"click":_vm.saveClicked}},[_c('img',{attrs:{"src":"/assets/icons/save.png"}}),_vm._v(" Enregistrer")]):_vm._e(),(_vm.saving)?_c('div',{staticClass:"modifs"},[_vm._v(" Modifications enregistrées ! ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }